import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const WindowBattery = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 14" {...props}>
    <path
      d="M15.598 4.43799H3.98438V9.56071H15.598V4.43799Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M19.1549 4.43863V3.97292C19.1549 3.23185 18.8553 2.52113 18.3219 1.99712C17.7885 1.4731 17.0651 1.17871 16.3108 1.17871H3.51212C2.7578 1.17871 2.03438 1.4731 1.501 1.99712C0.967619 2.52113 0.667969 3.23185 0.667969 3.97292V10.0271C0.667969 10.7681 0.967619 11.4788 1.501 12.0029C2.03438 12.5269 2.7578 12.8213 3.51212 12.8213H16.3108C17.0651 12.8213 17.7885 12.5269 18.3219 12.0029C18.8553 11.4788 19.1549 10.7681 19.1549 10.0271V9.56135H20.577C20.9542 9.56135 21.3159 9.41415 21.5826 9.15215C21.8493 8.89014 21.9991 8.53478 21.9991 8.16424V5.83573C21.9991 5.4652 21.8493 5.10984 21.5826 4.84783C21.3159 4.58582 20.9542 4.43863 20.577 4.43863H19.1549Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
